module.exports = __webpack_public_path__ + "static/media/ic_follow_outlined.c76145bd.svg";